import { StyleConfig } from '@chakra-ui/react';

const link: StyleConfig = {
  baseStyle: { color: 'royalBlue', fontFamily: 'body' },
};

export default link;
